import React, { useRef, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';

import closeIcon from '../../../../Assets/close-icon.svg';
import { serviceConsumer } from '../../../../network/ServiceConsumer';
import { handlePhotoUpload } from '../../../../helper/handleUploads';
import AddButton from '../../../AddButton/AddButton';
import Loader from '../../../Loader/Loader';
import CustomInput from '../CustomInput';
import JudgeRegionField, { listedInDirectory, regionOf } from '../JudgeRegionField';

const EditCollaboratorModal = ({ editCollab, getCollabOnEdit, setEditCollab, type }) => {
    const [imgError, setImgErr] = useState('');
    const [logo, setLogo] = useState(editCollab?.photo);
    const [upl, setUpl] = useState('');
    const [loading, setLoading] = useState(false);
    const imgInputRef = useRef(null);
    let EventID = localStorage.getItem('ID');

    const handleLOgo = () => {
        imgInputRef.current.click();
    };

    let collab;
    if (editCollab.from === "adjucators") collab = "Adjudicator"
    else if (type === "feis" && editCollab.from === "musician") collab = "Musician"
    else if (editCollab.from === "sponser") collab = "Sponsor"
    else if (editCollab.from === "musician" && type === "grade") collab = "Examiner"
    console.log(collab)

    // an adjudicator has a region, not a typed location (card 930d3ac0, Devin
    // 2026-10-27); left blank here, the judge's region stays as it is
    const isAdjudicator = editCollab.from === "adjucators";
    const listed = listedInDirectory(editCollab);

    //Initial values for formik
    const newCollabInitialValues = {
        fname: editCollab?.fname,
        lname: editCollab?.lname,
        location: editCollab?.location,
        region: regionOf(editCollab),
        photo: editCollab.photo,
    };

    const newCollabValidationSchema = Yup.object().shape({
        fname: Yup.string()
            .trim()
            .required('This field is required.')
            .max(50),
        lname: Yup.string()
            .trim()
            .required('This field is required.')
            .max(50),
        ...(isAdjudicator ? {} : {
            location: Yup.string()
                .trim()
                .required('This field is required.')
                .max(50),
        }),
    });

    const handleFileSelect = async (event) => {
        handlePhotoUpload(event, setLoading, setLogo, setUpl, setImgErr);
    };

    const addCollab = async (values, formikHelpers) => {
        const payload = {
            fname: values.fname,
            lname: values.lname,
            ...(isAdjudicator
                ? (!listed && values.region ? { region: values.region } : {})
                : { location: values.location }),
            type: values.type,
            photo: logo,
            eventId: EventID,
        };
        try {

            setLoading(true);
            const url = `${process.env.REACT_APP_BASE_URL}/people/${editCollab?._id}`;///people/musician,/grade-exam/examiner
            await serviceConsumer('PUT', url, payload);
            setEditCollab(null)
            getCollabOnEdit(editCollab.from)
            setLoading(false);
        } catch (error) {
            console.log(error)
            setLoading(false);
        }
    };

    const closeModalHandler = () => {
        setEditCollab(null)
    }

    const deleteLogoHandler = () => {
        setLogo("")
        setUpl("")
    }

    return (
        <>
            {loading && <Loader />}
            <Modal className="addDancerScroll" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }} open={true}>
                <Box>
                    <div style={{ maxHeight: '100vh', padding: '5px 100vw', overflow: 'scroll', }}>
                        <div className={logo ? "editCollab" : "main-div-add-adj"}>
                            <div className="close-div mt-4 mb-1">
                                <img src={closeIcon} alt="close-icon" className="close-icon" onClick={closeModalHandler} />
                            </div>
                            <p className="color-subtitle text-center mb-4" style={{ marginTop: '40px' }}>{`Edit ${collab}`}</p>
                            <div className="d-flex align-items-center justify-content-center" style={{ background: 'white,borderRadius: 14px;' }}>
                                <Formik
                                    initialValues={newCollabInitialValues}
                                    validationSchema={newCollabValidationSchema}
                                    onSubmit={addCollab}
                                >
                                    {(formik) => (
                                        <Form className="form form-label-right" autoComplete="off">
                                            <CustomInput label="First name" name="fname" type="text" placeholder="First Name" formik={formik} />
                                            <CustomInput label="Last name" name="lname" type="text" placeholder="Last Name" formik={formik} />
                                            {isAdjudicator
                                                ? <JudgeRegionField formik={formik} collab={editCollab} />
                                                : <CustomInput label="Location" name="location" type="text" placeholder="Location" formik={formik} />}

                                            <input type="file" ref={imgInputRef} style={{ display: 'none' }} onChange={handleFileSelect} />

                                            <div className="d-grid">
                                                <label className="label-head-org" style={{ marginLeft: '1px' }} >Photo:</label>
                                                {logo && <img src={logo} alt="collab" style={{ width: "50px", height: "50px" }} className="mb-1" />}
                                                {logo ?
                                                    <div>
                                                        <button onClick={deleteLogoHandler} className="outlined mt-0">Delete</button>
                                                    </div>
                                                    : <div>
                                                        <AddButton onClick={handleLOgo} className="plusIconbtn mt-0 mb-2">Add Photo</AddButton>
                                                    </div>}

                                                {imgError && (<span className="error mt-2" style={{ width: '248px' }}>{imgError}</span>)}
                                                {upl && <span className="auth-suc">{upl}</span>}
                                            </div>
                                            {console.log(formik)}
                                            <div className="mb-2 d-flex justify-content-center">
                                                <button className={formik.isValid && formik.dirty ? 'updateChange' : 'updateChangeDisabled'}
                                                    style={{ fontWeight: '500', height: '42px', padding: '9px 11px', }}
                                                    type="submit"
                                                    disabled={!formik.isValid}
                                                // disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    );
};


export default EditCollaboratorModal